import React, {forwardRef} from 'react';
import {makeStyles} from "@mui/styles";
import {InputFileAcceptMimes, InputFileAcceptTypes} from "../../../../core/constants/enums";
import accepts from "attr-accept";

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const UploadButton = forwardRef(({
                                     multiple,
                                     id,
                                     onFileSelect,
                                     children,
                                     className,
                                     accept = [
                                         InputFileAcceptMimes.images,
                                         InputFileAcceptTypes.heic,
                                         InputFileAcceptTypes.heif,
                                     ],
                                     disabled,
                                     labelClassName,
                                 }, ref) => {
        const classes = useStyles();
        if (accept.includes(InputFileAcceptMimes.videos)) {
            accept = [
                ...accept.filter(e => e !== InputFileAcceptMimes.videos),
                ...InputFileAcceptMimes.videos.split(',')
            ]
        }


        /**
         * Calls the onFileSelect if it exists and there is a selected file with the returned array of fileListTOArray
         * function.
         * @param e {Event}
         */
        const onFileAdd = async (e) => {
            e.target.files.length
            && onFileSelect
            && !disabled
            && onFileSelect(await fileListToArray(e.target.files))
        }


        /**
         * For every selected file, if the file has the accepted types, returns the files array.
         * if no multiple, then only returns the first selected file.
         *
         * @param files {FileList}
         * @return {Promise<FileList>}
         */
        const fileListToArray = async (files) => {
            const dataTransfer = new DataTransfer();
            for (let index = 0; index < files.length; index++) {
                let file = files.item(index);
                if (!accepts(files.item(index), accept))
                    continue;
                if (file.name.endsWith(InputFileAcceptTypes.heic) || file.name.endsWith(InputFileAcceptTypes.heif) || file.type === 'image/heic' || file.type === 'image/heif') {
                    const url = URL.createObjectURL(file);
                    let blobRes = await fetch(url)
                    let blob = await blobRes.blob()
                    const heic2any = require('heic2any');
                    let conversionResult = await heic2any({blob, quality: 1, type: 'image/png'});
                    file = new File(Array.isArray(conversionResult) ? conversionResult : [conversionResult], file.name.replace(/\.heic|\.heif/g, '.png'), {type: 'image/png'})
                }
                if (multiple) {
                    dataTransfer.items.add(file);
                } else {
                    dataTransfer.items.add(file);
                    break;
                }
            }
            return dataTransfer.files;
        }


        return (
            <div className={className} onClick={e => e.stopPropagation()}>
                <input
                    ref={ref}
                    accept={accept.join(', ')}
                    className={classes.input}
                    id={id}
                    multiple={multiple}
                    type="file"
                    onChange={onFileAdd}
                    onClick={(e) => e.target.value = ''}
                />
                <label htmlFor={id} className={labelClassName}>
                    {children}
                </label>
            </div>
        );
    }
);

export default UploadButton;
